import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'eu', name: 'Euskara', flag: '🟢🔴' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ka', name: 'ქართული', flag: '🇬🇪' },
];

// Map browser language codes to our supported languages
const browserLangMap = {
  'fr': 'fr', 'fr-FR': 'fr', 'fr-CA': 'fr', 'fr-BE': 'fr',
  'en': 'en', 'en-US': 'en', 'en-GB': 'en', 'en-AU': 'en',
  'es': 'es', 'es-ES': 'es', 'es-MX': 'es', 'es-AR': 'es',
  'it': 'it', 'it-IT': 'it',
  'ja': 'ja', 'ja-JP': 'ja',
  'de': 'de', 'de-DE': 'de', 'de-AT': 'de', 'de-CH': 'de',
  'ru': 'ru', 'ru-RU': 'ru',
  'ka': 'ka', 'ka-GE': 'ka',
};

const detectBrowserLanguage = () => {
  const browserLangs = navigator.languages || [navigator.language];
  for (const lang of browserLangs) {
    if (browserLangMap[lang]) return browserLangMap[lang];
    const shortCode = lang.split('-')[0];
    if (browserLangMap[shortCode]) return browserLangMap[shortCode];
  }
  return 'fr'; // Default to French
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('asp-language');
    if (saved) return saved;
    // Auto-detect from browser
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem('asp-language', language);
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export default LanguageContext;
